import React, { useEffect } from 'react'
import millify from 'millify'
import { Typography, Row, Col, Statistic } from 'antd'
import { Link } from 'react-router-dom'

import {useGetCryptosQuery} from '../services/cryptoApi'
import { Cryptocurrencies, News } from '.'

const { Title } = Typography;


const Homepage = () => {
    const {data, isFetching} = useGetCryptosQuery(10)
    
    const globalStats = data?.data?.stats ; 


    /* useEffect(() => {
        fetch("https://coinranking1.p.rapidapi.com/coins?referenceCurrencyUuid=yhjMzLPhuIDl&timePeriod=24h&tiers=1&orderBy=marketCap&orderDirection=desc&limit=50&offset=0", {
	"method": "GET",
	"headers": {
		"x-rapidapi-host": "coinranking1.p.rapidapi.com",
		"x-rapidapi-key": "4f5dfa972cmshcb6ce13b08bd807p15ab36jsnd23beb34c308"
    }
    })
    .then(response => {
        console.log(response);
    })
    .catch(err => {
        console.error(err);
    });
    }, []) */

    if(isFetching) return 'Fetching...'
 


    return (
        
            <>
                <Title level={2} className="heading">
                    Global Crypto Statistics
                </Title>
                <Row>
                    <Col span={12}><Statistic title="Total Cryptocurrencies" value={globalStats?.total} /></Col>
                    <Col span={12}><Statistic title="Total Exchanges" value={millify(globalStats?.totalExchanges || 0)} /></Col>
                    <Col span={12}><Statistic title="Total Market Cap" value={millify(globalStats?.totalMarketCap || 0)} /></Col>
                    <Col span={12}><Statistic title="Total 24h Volume" value={millify(globalStats?.total24hVolume || 0)} /></Col>
                    <Col span={12}><Statistic title="Total Markets" value={millify(globalStats?.totalMarkets || 0)} /></Col>
                </Row>
                <div className="home-heading-container">
                    <Title level={2} className="home-title">Top 10 Cryptocurrencies in the world</Title>
                    <Title level={3} className="show-more"><Link to="/cryptocurrencies"> Show More </Link></Title>
                </div>
                <Cryptocurrencies simplified />

                <div className="home-heading-container">
                    <Title level={2} className="home-title">Latest Crypto News</Title>
                    <Title level={3} className="show-more"><Link to="/news"> Show More </Link></Title>
                </div>
                <News simplified />
                


            </>
        
    )
}

export default Homepage
